<script>
export default {
  name: 'BrainCircuitIcon',
  props: {
    size: { type: [Number, String], default: 24 },
    color: { type: String, default: 'currentColor' },
  },
}
</script>

<template>
  <!-- Icone de TRACO (Lucide brain-circuit), nao de preenchimento: o `stroke`
       vai uma vez no <g> e cada <circle> declara `fill` como `none` explicito, senao
       o UA os preenche. Mesmo contrato de `tune.vue`. -->
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    >
      <path
        d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"
      />
      <path d="M9 13a4.5 4.5 0 0 0 3-4" />
      <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
      <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
      <path d="M6 18a4 4 0 0 1-1.967-.516" />
      <path d="M12 13h4" />
      <path d="M12 18h6a2 2 0 0 1 2 2v1" />
      <path d="M12 8h8" />
      <path d="M16 8V5a2 2 0 0 1 2-2" />
      <circle cx="16" cy="13" r=".5" fill="none" />
      <circle cx="18" cy="3" r=".5" fill="none" />
      <circle cx="20" cy="21" r=".5" fill="none" />
      <circle cx="20" cy="8" r=".5" fill="none" />
    </g>
  </svg>
</template>
